var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4.928 0 0 4.928 0 11C0 17.072 4.928 22 11 22C17.072 22 22 17.072 22 11C22 4.928 17.072 0 11 0ZM9.9 18.7V16.5H12.1V18.7H9.9ZM13.387 11.187L14.377 10.175C15.499 9.053 15.884 7.128 14.586 5.335C13.596 3.96 12.001 3.091 10.329 3.355C8.624 3.619 7.249 4.851 6.776 6.468C6.6 7.084 7.04 7.7 7.678 7.7H8.008C8.437 7.7 8.778 7.392 8.91 6.985C9.273 5.94 10.406 5.247 11.627 5.588C12.397 5.808 13.013 6.479 13.156 7.271C13.299 8.041 13.057 8.767 12.551 9.251L11.187 10.637C10.725 11.099 10.362 11.671 10.142 12.309C9.988 12.76 9.9 13.244 9.9 13.75V14.3H12.1C12.1 13.794 12.155 13.398 12.243 13.046C12.441 12.254 12.837 11.748 13.387 11.187Z",
    fill: "#B9C1C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDark);
export default __webpack_public_path__ + "static/media/help-dark.7572cbc5a85db2f6fe6abcd289192d3c.svg";
export { ForwardRef as ReactComponent };